module.exports = __webpack_public_path__ + "static/media/bazooka_farmstar.e00b5d68.png";